import { render, staticRenderFns } from "./com-copyright.vue?vue&type=template&id=217bf1b0&"
import script from "./com-copyright.vue?vue&type=script&lang=js&"
export * from "./com-copyright.vue?vue&type=script&lang=js&"
import style0 from "./com-copyright.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports